import { createContext, useContext } from "react";

// PoC #popout: a popout window is a portal in the SAME JS heap, so the module-level
// `document` is always the main window's. Any overlay that portals to `document.body`
// (PrimeReact Dropdown panels, tooltips, nested Dialogs) lands in the wrong window and
// is positioned with a rect measured in the popout's viewport (issue #375).
//
// ModalBase resolves the body of the document it actually lives in and publishes it
// here; overlays inside the modal read it for `appendTo`. Context crosses portals, so
// it reaches everything rendered inside the Dialog.
const PortalHostContext = createContext(null);

export const PortalHostProvider = PortalHostContext.Provider;

// Body of the host document, falling back to the main window when there's no provider.
export function usePortalHostBody() {
  return useContext(PortalHostContext) ?? document.body;
}

export default PortalHostContext;
